"use client";

import LogoS from "@/assets/logo-s.svg";
import Section from "@/components/ui/Section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { textKey } from "@/lib/list-keys";
import { tinaField } from "@/lib/utils";

export default function FAQs({ tinaFieldData, pretitle, title, subtitle, faqs }) {
  return (
    <Section wrapperClassName="bg-muted">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
        <div className="flex flex-col gap-4 items-start">
          {pretitle && (
            <Badge data-tina-field={tinaField(tinaFieldData, "pretitle")} className="mb-2">
              {pretitle}
            </Badge>
          )}

          <h2 data-tina-field={tinaField(tinaFieldData, "title")} className="h1">
            {title}
          </h2>
          {subtitle && (
            <p data-tina-field={tinaField(tinaFieldData, "subtitle")} className="p-lg text-balance">
              {subtitle}
            </p>
          )}
          <div className="flex-1 items-end hidden lg:flex">
            <LogoS className="size-16 text-primary" />
          </div>
        </div>
        {faqs?.length > 0 && (
          <Accordion type="single" collapsible defaultValue={textKey(faqs[0]?.question, 0)} className="w-full space-y-3">
            {faqs.map((faq, index) => {
              const faqKey = textKey(faq.question, index);
              return (
                <AccordionItem key={faqKey} value={faqKey}>
                  <AccordionTrigger>
                    <span data-tina-field={tinaField(faqs[index], "question")}>{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent>
                    <p className="p-lg" data-tina-field={tinaField(faqs[index], "answer")}>
                      {faq.answer}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        )}
      </div>
    </Section>
  );
}
